import {
  CartLocation,
  type CartLocationValue,
  EMPTY_ADD_TO_CART_METADATA,
  STOREFRONT_CART_ATTRIBUTES,
} from "@tablescape/constants";
import { TablescapeContext, TablescapeEvent } from "@tablescape/context";
import { formatMsrpValue } from "@tablescape/utilities";

const isCartLocationValue = (value: string): value is CartLocationValue =>
  Object.values(CartLocation).some((location) => location === value);

export const action = async (e: MouseEvent) => {
  const addToCart = e.target as HTMLElement;
  e.preventDefault();

  if (!addToCart) {
    return;
  }

  const variantSelectorElement = addToCart.closest<HTMLElement>(
    "[data-product-selected-variant-id]"
  );

  if (
    !variantSelectorElement ||
    !variantSelectorElement.dataset?.productSelectedVariantId
  ) {
    return;
  }

  const locationElement = addToCart.closest<HTMLElement>(
    "[data-cart-location]"
  );
  const locationValue = locationElement?.dataset.cartLocation;
  const location =
    locationValue && isCartLocationValue(locationValue)
      ? locationValue
      : CartLocation.ADD_TO_CART_BUTTON;

  try {
    TablescapeContext.emit(TablescapeEvent.TOGGLE_CART, {
      ui: {
        cartDrawerOpen: true,
        cartDrawerUserToggled: false,
        giftNoteDrawerOpen: false,
        productVariantDrawerOpen: false,
      },
    });

    TablescapeContext.emit(TablescapeEvent.ADD_TO_CART, {
      cart: {
        lines: [
          {
            attributes: [
              {
                key: STOREFRONT_CART_ATTRIBUTES.MSRP,
                value: String(
                  formatMsrpValue(
                    variantSelectorElement.dataset.productSelectedVariantMsrp
                  )
                ),
              },
              ...(variantSelectorElement.dataset
                .productSelectedVariantShippingNote
                ? [
                    {
                      key: STOREFRONT_CART_ATTRIBUTES.PREORDER,
                      value: String(true),
                    },
                  ]
                : []),
            ],
            id: variantSelectorElement.dataset.productSelectedVariantId,
            quantity: 1,
          },
        ],
        metadata: {
          ...EMPTY_ADD_TO_CART_METADATA,
          location,
        },
      },
    });
  } catch (error) {
    console.error(error);
  }
};
